import { create } from "zustand";

export const useInviteFriendStore = create((set) => ({
  recaptchaSiteKey: "",
  setRecaptchaSiteKey: (recaptchaSiteKey) => set({ recaptchaSiteKey }),
}));
